export default __webpack_public_path__ + "2204da3e83ba44eda492f70b7bfba632.png";